import { DeleteIcon } from '@/lib/constants/icons.js';
import * as Popover from '@radix-ui/react-popover';
import Button from './Button.jsx';
import { useState } from 'react';

const Portal = ({ children, container }) => {
  if (!container) {
    return children;
  }
  return <Popover.Portal container={container}>{children}</Popover.Portal>;
};

const DeleteButton = ({ title, confirmText = 'Are you sure?', onClick, disabled, className = '', container, align = 'end', loading }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open) => {
    setIsOpen(open);
  };

  const handleConfirmClick = () => {
    onClick();
    setIsOpen(false); // Close the popover after confirming
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Popover.Trigger asChild>
        <div>
          <Button title={title} loading={loading} icon={DeleteIcon} size="sm" className={`ghost delete-btn ${isOpen ? 'open' : ''} ${className}`} onClick={() => handleOpenChange(true)} disabled={disabled} />
        </div>
      </Popover.Trigger>
      <Portal container={container}>
        <Popover.Content className="delete-button-popover" side="left" align={align} sideOffset={-24}>
          <div onClick={handleConfirmClick}>{confirmText}</div>
        </Popover.Content>
      </Portal>
    </Popover.Root>
  );
};

export default DeleteButton;
